angular.module 'zc.projects'

.controller 'NewProjectCtrl', ($scope, $translate, $state, Page, Project) ->
  Page.setBodyClass 'account-bg'
  $translate('projects.controllers.newController.siteRegistration').then (translation) ->
    Page.setTitle translation

  $scope.submit = (project) ->
    Project.create(project).then (project) ->
      # TODO: first move to installation
      # and then move to show after installation completes
      # $state.go 'admin.projects.settings.installation',
      # $state.go 'admin.projects.settings.installation',
      $state.go 'admin.projects.campaigns.list',
        projectId: project.id



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/controllers/new_controller.js.coffee